// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__kifJX","importantInfo":"styles_importantInfo__1YSW3"};